import React, { useEffect, useState } from 'react'
import Layout from '../../../components/Layout/Layout'
import { useNavigate } from 'react-router-dom'
import CreateNewEvent from './CreateNewEvent'
import { Modal } from 'antd'
import axios from 'axios'
import 'bootstrap-icons/font/bootstrap-icons.min.css'

const AdminPackingListIndex = () => {
  const navigate = useNavigate()
  const [events, setEvents] = useState([])
  const [visibleAddEventModal, setVisibleAddEventModal] = useState(false)
  const [stockAddData, setStockAddData] = useState({
    eventTitle: '',
  })

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const { data } = await axios.get('/api/v1/admin/packing-list/events')
        setEvents(data)
      } catch (error) {
        console.log('Failed to fetch events:', error)
      }
    }

    fetchEvents()
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setStockAddData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const { data } = await axios.post(
        '/api/v1/admin/packing-list/event/add',
        { eventTitle: stockAddData.eventTitle }
      )
      closeModal()
      setEvents((prevEvents) => [data.data, ...prevEvents])
    } catch (error) {
      console.log(
        'Failed to add event:',
        error.response?.data.message || error.message
      )
    }
  }

  const handleViewDetails = (bookId) => {
    navigate(`/admin/packing-list/details/${bookId}`)
  }

  const groupItemDetails = (bookId) => {
    navigate('/admin/group-item')
  }

  const openModal = () => {
    setVisibleAddEventModal(true)
  }

  const closeModal = () => {
    setVisibleAddEventModal(false)
    setStockAddData({ eventTitle: '' })
  }

  // Parked: no delete button in the event list yet, the endpoint exists.
  // eslint-disable-next-line no-unused-vars
  const handleDelete = async (id) => {
    if (window.confirm('Confirm Delete?')) {
      try {
        await axios.delete(`/api/v1/admin/packing-list/event/${id}`)
        setEvents((prevEvents) =>
          prevEvents.filter((event) => event._id !== id)
        )
      } catch (error) {
        console.error('Failed to delete record:', error)
      }
    }
  }

  return (
    <Layout title={'Packing List'}>
      <div className='pt-3 mx-3'>
        <div className='text-end mb-3'>
          <button
            type='button'
            className='btn btn-primary btn-sm'
            style={{ marginRight: '20px' }}
            onClick={() => groupItemDetails()}
          >
            Group Items
          </button>
          <button
            type='button'
            className='btn btn-info btn-sm'
            onClick={openModal}
            aria-label='Add New Packing List'
            title='Add New Packing List'
          >
            <i className='bi bi-plus-lg'></i>
          </button>
        </div>
        <table className='table'>
          <thead>
            <tr>
              <th scope='col'>Date</th>
              <th scope='col'>Event</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event._id}>
                <td>
                  {new Date(event.recordDate).toISOString().split('T')[0]}
                </td>
                <td>{event.event}</td>
                <td style={{ textAlign: 'right' }}>
                  <button
                    onClick={() => handleViewDetails(event._id)}
                    className='btn btn-success btn-sm '
                  >
                    View
                  </button>
                  {/* <button
                    className='btn btn-outline-danger btn-sm ms-4'
                    onClick={() => handleDelete(event._id)}
                  >
                    <i className='bi bi-trash3'></i>
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Modal
        closable={false}
        onCancel={closeModal}
        footer={null}
        open={visibleAddEventModal}
      >
        <CreateNewEvent
          closeModal={closeModal}
          handleSubmit={handleSubmit}
          handleChange={handleChange}
          eventTitle={stockAddData.eventTitle}
        />
      </Modal>
    </Layout>
  )
}

export default AdminPackingListIndex
